export const matKeys = {
	/**
	 * Material key for siding floor. Used to:
	 * 1. Adjusting UV scaling for the siding floor material.
	 * 2. Setting the material color when the outer joist is enabled.
	 * 3. Configuring the maxSimultaneousLights for DogKennel.
	 */
	sidingFloor: 'siding_floor_mat',

	/**
	 * Material key for transom black material. Used to:
	 * Set specularPower to 30 without changing diffuseColor.
	 */
	transomBlack: 'transom_black_mat',

	/**
	 * Material key for door metal vertical material. Used to:
	 * Set specularPower to 30 without changing diffuseColor.
	 */
	doorMetalVertical: 'door_metal_vertical_mat',
};
